import script from "./FahrzeugTyp.vue?vue&type=script&setup=true&lang=js"
export * from "./FahrzeugTyp.vue?vue&type=script&setup=true&lang=js"

import "./FahrzeugTyp.vue?vue&type=style&index=0&id=37d77d7e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d77d7e"]])

export default __exports__